export const INVOICES_ALL = 'INVOICES_ALL';
export const INVOICES_ALL_SUCCESS = 'INVOICES_ALL_SUCCESS';
export const INVOICES_GET = 'INVOICES_GET';
export const INVOICES_GET_ACCESS_CODE = 'INVOICES_GET_ACCESS_CODE';
export const INVOICES_GET_ALL = 'INVOICES_GET_ALL';
export const INVOICES_GET_LAST = 'INVOICES_GET_LAST';
export const INVOICES_GET_LAST_SUCCESS = 'INVOICES_GET_LAST_SUCCESS';
export const INVOICES_SET_BOARD_DATA = 'INVOICES_SET_BOARD_DATA';
export const INVOICES_SET_BOARD_ORDERED = 'INVOICES_SET_BOARD_ORDERED';
export const INVOICES_SET_BOARD_COLUMNS = 'INVOICES_SET_BOARD_COLUMNS';
export const INVOICES_SET_MODIFIED_INVOICE = 'INVOICES_SET_MODIFIED_INVOICE';
export const INVOICES_GET_ALL_SUCCESS = 'INVOICES_GET_ALL_SUCCESS';
export const INVOICES_GET_SUCCESS = 'INVOICES_GET_SUCCESS';
export const INVOICES_GET_ACCESS_CODE_SUCCESS =
  'INVOICES_GET_ACCESS_CODE_SUCCESS';
export const INVOICES_CREATE = 'INVOICES_CREATE';
export const INVOICES_CREATE_SUCCESS = 'INVOICES_CREATE_SUCCESS';
export const INVOICES_UPDATE = 'INVOICES_UPDATE';
export const INVOICES_UPDATE_SUCCESS = 'INVOICES_UPDATE_SUCCESS';
export const INVOICES_UPDATE_PAGINATION = 'INVOICES_UPDATE_PAGINATION';
export const INVOICES_DELETE = 'INVOICES_DELETE';
export const INVOICES_DELETE_SUCCESS = 'INVOICES_DELETE_SUCCESS';
export const INVOICES_STATUSES = 'INVOICES_STATUSES';
export const INVOICES_STATUSES_SUCCESS = 'INVOICES_STATUSES_SUCCESS';
